import { format } from "date-fns/esm";
import { de, enUS as en } from "date-fns/locale";

const locales = { de, en, "de-DE": de, "en-US": en };

export default function (
	date: Date,
	_format: string = "PP",
	options?: {
		locale?: keyof typeof locales | string;
		weekStartsOn?: 0 | 1 | 2 | 3 | 4 | 5 | 6;
		firstWeekContainsDate?: number;
		useAdditionalWeekYearTokens?: boolean;
		useAdditionalDayOfYearTokens?: boolean;
	}
) {
	return format(date, _format, {
		...(options || {}),
		locale: options?.locale ? locales[options.locale] : undefined,
	});
}
